module.exports = __webpack_public_path__ + "media/images/varta/AKB_Banner_698x280-062f908fb61caad57bd541b3a0e3c958.png";